<div class="org-node" [ngClass]="getNodeClass()">
  <div class="node-content">
    <span class="expand-toggle" *ngIf="isExpandable()" (click)="toggleNode()">
      <i class="fas" [class.fa-chevron-right]="!node.expanded"
         [class.fa-chevron-down]="node.expanded"></i>
    </span>
    <i [class]="getNodeIconClass()"></i>
    <span class="node-name">{{ node.name }}</span>
    <div class="node-actions">
      <button *ngIf="node.type !== 'company'" class="btn-icon" (click)="onMoveUp()"
              [disabled]="!canMoveUp()" [title]="'user_management.organization_settings.move_up' | translate">
        <i class="fas fa-arrow-up"></i>
      </button>
      <button *ngIf="node.type !== 'company'" class="btn-icon" (click)="onMoveDown()"
              [disabled]="!canMoveDown()" [title]="'user_management.organization_settings.move_down' | translate">
        <i class="fas fa-arrow-down"></i>
      </button>
      <button class="btn-icon" (click)="onEdit()" [title]="'user_management.organization_settings.edit' | translate">
        <i class="fas fa-edit"></i>
      </button>
      <button class="btn-icon" (click)="onAddChild()" [title]="'user_management.organization_settings.add_sub_department' | translate">
        <i class="fas fa-plus"></i>
      </button>
      <button *ngIf="node.type !== 'company'" class="btn-icon danger" (click)="onDelete()" [title]="'user_management.organization_settings.delete' | translate">
        <i class="fas fa-trash"></i>
      </button>
    </div>
  </div>

  <!-- 遞歸顯示子部門 -->
  <div class="org-children" *ngIf="node.expanded && getDepartmentChildren().length > 0">
    <app-organization-management-tree-node
      *ngFor="let child of getDepartmentChildren(); let i = index"
      [node]="child"
      [parent]="node"
      [siblings]="getDepartmentChildren()"
      [nodeIndex]="i"
      [level]="level + 1"
      (moveUp)="moveUp.emit($event)"
      (moveDown)="moveDown.emit($event)"
      (editNode)="editNode.emit($event)"
      (addChild)="addChild.emit($event)"
      (deleteNode)="deleteNode.emit($event)"
      (toggleExpanded)="toggleExpanded.emit($event)">
    </app-organization-management-tree-node>
  </div>
</div>